// extracted by mini-css-extract-plugin
export default {"add_todo_td_input":"style_add_todo_td_input__eyLth"};